 <!-- DIALOG-BACKUP -->
 <div class="master-modal" role="dialog">
   <div class="modal-dialog">
     <!-- Modal content-->
     <div class="modal-content">
       <!-- Modal-Header -->
       <div class="modal-header">
         <h4 class="modal-title"> OTP verification </h4>
         <div class="modal_close_btn">
           <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
         </div>
       </div>
       <form>
         <!-- Modal content-->
         <perfect-scrollbar class="modal-body-scrollbar">
           <div mat-dialog-content>
             <!-- Modal-Body -->
             <div class="modal-body">
               <form [formGroup]="otpForm" class="form-section">
                 <div class="custom-form-group">
                   <label class="custom-label" for="">OTP password sent to your registered Email, please specify is displayed.<span class="star">*</span></label>
                   <div class="custom-form-control">
                     <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter otp" formControlName="otp">
                       <mat-error *ngIf="invalidotp">
                         <span>Please provide a valid OTP</span>
                       </mat-error>
                     </mat-form-field>
                   </div>
                 </div>
               </form>
             </div>
           </div>
         </perfect-scrollbar>
         <!-- Modal-Footer -->
         <div class="modal-footer">
           <div mat-dialog-actions class="modal_footer">
             <button type="button" mat-button (click)="dialogClose()" class="modal-cancel-btn modal-footer-btn">
               <span>Cancel</span>
             </button>
             <button type="submit" mat-button class="modal-save-btn global-btn modal-footer-btn" (click)="changeStatus()">
               <span>Submit</span>
             </button>
           </div>
         </div>
       </form>
     </div>
   </div>
 </div>




